import React, { Component } from 'react'
import { View, StyleSheet, Platform, TextInput } from 'react-native'
import { JDText, JDImage, JDDevice, JDTouchable, JDTouchableWithoutFeedback, JDToast } from '@jdreact/jdreact-core-lib'
import PropTypes from "prop-types"
import { getVerifyCode, getUserPhone, goLogin } from '../../../utils/api'
import { jumpUrl } from '../../../utils/tools'

import checkBox from '../../../images/detail/checkBox.png'
import checkedBox from '../../../images/detail/checkedBox.png'
const clearIcon = 'https://img12.360buyimg.com/imagetools/jfs/t1/114381/8/5512/631/5eb4f23fE8afdd302/02f9cf156d12fa18.png'
export default class LiuzZiCompon extends Component{
	static contextTypes = {
		router: PropTypes.object
	};
	static propTypes = {
		liuziInfo: PropTypes.object,
		close:PropTypes.func,
		propOnConfirm: PropTypes.func,
	};
	constructor() {
		super();
		this.state = {
			verifyPrompt: '获取验证码',
			phoneNumber: '',
			agressProtocol: false,
			noYanzheng: false,
			showVerifyCode: false, // 是否显示验证码弹窗
			verifyCode: "", // 验证码
			errMsg: '',
			isShowErrMsg: false,
			isFoucs: false
		}
	}

	componentDidMount(){
		// 登陆后获取用户手机号---是否强制校验登陆态
		// goLogin(this.getTel())
		this.getTel()
	}
	onSubmitEditing = (postUrl) => {

	}
	onFocus = (postUrl) => {
		this.setState({
			isFoucs: true
		})
	}
	onBlur = (postUrl) => {
		this.setState({
			isFoucs: false
		})
	}
	getTel = (postUrl) => {
		getUserPhone().then((res) => {
			const { code, data } = res;
			if (code === '1' && data) {
				this.setState({
					orginTel: data,
					phoneNumber: data
				})
			}
		}).catch(err => console.log("获取用户手机号失败", err))
	}
	onChangePhoneNumber = (text) => {
		if (text.length == 11 && text !== this.state.orginTel) {
				this.setState({
					phoneNumber: text,
					showVerifyCode: true
				})
		} else {
			this.setState({
				phoneNumber: text,
				showVerifyCode: false
			})
		}
	}
	// 发送验证码
	sendVerifyCode = () => {
		const {phoneNumber, verifyPrompt} = this.state
		if (!phoneNumber.length) return;

		if (!/^1\d{2}(\d{4}|\*{4})\d{4}$/.test(phoneNumber)) {
			this.showErrFun('请输入正确的手机号码')
			return;
		}

		if (!this.verifyCodeTimer || verifyPrompt === '获取验证码') {
			// 发送验证码需要的参数
			let codeParams = {
				phone: phoneNumber,
				msgType:1
			};

			getVerifyCode(codeParams).then((res) => {
					const { code, data, msg } = res;
					// 获取验证码成功。开始计时器
					if (code == 1 && data) {
						let timeStart = 60;
						this.setState({
							verifyPrompt: `${timeStart--}s后可重新获取`
						})

						this.verifyCodeTimer = setInterval(() => {
							if (timeStart < 0) {
								clearInterval(this.verifyCodeTimer);
								this.verifyCodeTimer = null;
								this.setState({
									verifyPrompt: "获取验证码"
								})
							} else {
								this.setState({
									verifyPrompt: `${timeStart--}s后可重新获取`
								})
							}
						}, 1000);
					} else {
						this.showErrFun(`获取验证码失败，请稍后重试: ${msg || "网络错误"}`)
					}
				})
				.catch((err) => {
					console.log("获取验证码失败", err);
					this.showErrFun('获取验证码失败，请稍后重试')
				});
			// 传入点击获取验证码
			// this.propOnClickSendCode && this.propOnClickSendCode();
		}
	}
	
	showErrFun = (msg) => {
		this.setState({
			errMsg: msg,
			isShowErrMsg: true
		}, ()=> setTimeout(()=>{
			this._onHide()
		},2000))
	}

// 点击确定
	clickConfirm = () => {
		
		const { agressProtocol, phoneNumber, showVerifyCode, verifyCode} = this.state
		if (phoneNumber.length !== 11) {
			this.showErrFun('手机号错误')
			return false;
		};
		if (showVerifyCode &&!/^1\d{2}(\d{4}|\*{4})\d{4}$/.test(phoneNumber)){
			this.showErrFun('手机号错误')
			return false;
		}
		if (showVerifyCode && !verifyCode){
			this.showErrFun('验证码错误')
			return false;
		}
		if (!agressProtocol) {
			this.showErrFun('请勾选协议')
			return false;
		}

		let data = {};

		// 需要验证码
		if (showVerifyCode) {
			data = { validMsg: verifyCode, msgType: 1 };
		}
		// 是否传入手机号
		if (phoneNumber.indexOf("*") == -1) {
			data = {
				...data,
				phone: phoneNumber,
			};
		}
		const { close, propOnConfirm } = this.props
		if (propOnConfirm) {
			propOnConfirm(data)
		} else {
			close();
		}
	}

	onChangeVerifyCode = (text) => {
		this.setState({
			verifyCode: text
		})
	}
	_onHide = () => { // 隐藏错误提示
		this.setState({
			errMsg: '',
			isShowErrMsg: false
		});
	};

	render() {
		let { phoneNumber, agressProtocol, showVerifyCode, verifyPrompt, verifyCode, isFoucs } = this.state
		let { advContent, advName } = this.props.liuziInfo
		return (
			<View style={[liuziStyles.liuziContainer, (isFoucs && Platform.OS === 'ios') ? {bottom: JDDevice.getRpx(600),paddingBottom: JDDevice.getRpx(100)}:null]}>
			<JDTouchableWithoutFeedback>
				<View style={liuziStyles.liuziBox}>
					<View style={liuziStyles.titleBox}>
						<JDText style={liuziStyles.titleText}>{advName}</JDText>
					</View>
					<View style={liuziStyles.tipsBox}>
						<JDText style={liuziStyles.tipsText}>{advContent}</JDText>
					</View>
					<View style={liuziStyles.telBox}>
							<TextInput
									autoFocus={false}
									onSubmitEditing={this.onSubmitEditing}
									style={liuziStyles.telInput}
									placeholder={'请输入手机号'}
									placeholderTextColor={'#CCCCCC'}
									value={phoneNumber}
									maxLength={11}
									onFocus={this.onFocus}
									onBlur={this.onBlur}
									onChangeText={(value) => this.onChangePhoneNumber(value)}
							/>
							{!!phoneNumber && <JDTouchable style={liuziStyles.telDeleBox} onPress={() => {this.setState({phoneNumber: ''})}}>
								<JDImage style={liuziStyles.telDeleIcon} source={{uri:clearIcon}}></JDImage>
							</JDTouchable>}
					</View>
					<View style={liuziStyles.line}></View>
					{(showVerifyCode && phoneNumber) && <View style={liuziStyles.telBox}>
							<TextInput
									autoFocus={false}
									style={liuziStyles.yanzhengInput}
									placeholder={'请输入验证码'}
									placeholderTextColor={'#CCCCCC'}
									maxLength={8}
									onFocus={this.onFocus}
									onBlur={this.onBlur}
									value={verifyCode}
									onChangeText={(value) => this.onChangeVerifyCode(value)}
							/>
							<JDTouchableWithoutFeedback contentContainerStyle={liuziStyles.vertycodeBox} onPress={this.sendVerifyCode}>
								<JDText style={liuziStyles.tipsText}>{verifyPrompt}</JDText>
							</JDTouchableWithoutFeedback>
					</View>}
					{(showVerifyCode && phoneNumber) && <View style={liuziStyles.line}></View>}
					<View style={liuziStyles.agreeBox}>
							<JDTouchableWithoutFeedback
								onPress={() => {this.setState({agressProtocol: !agressProtocol})}} contentContainerStyle={{}}>
									<View style={liuziStyles.agreeIconBox}>
										<JDImage style={liuziStyles.agreeIcon} source={agressProtocol ? checkedBox : checkBox}></JDImage>
										<JDText style={liuziStyles.agreeText}>我已阅读并同意</JDText>
									</View>
							</JDTouchableWithoutFeedback>
							

							<JDTouchableWithoutFeedback onPress={() => {
									this.props.close && this.props.close()
									setTimeout(()=>{
										jumpUrl('https://pro.m.jd.com/mall/active/2mi8cLLNYzjyoq1pyCnZXqpGhuNn/index.html', true)
									},0)
								}}>
								<JDText style={liuziStyles.agreeConText}>《用户信息授权使用说明》</JDText>
							</JDTouchableWithoutFeedback>
					</View>
					<JDTouchableWithoutFeedback onPress={this.clickConfirm}>
							<View style={liuziStyles.btnBox}><JDText style={liuziStyles.btnText}>确认订阅</JDText></View>
					</JDTouchableWithoutFeedback>
				</View>
			</JDTouchableWithoutFeedback>
			<JDToast show={this.state.isShowErrMsg} onHide={this._onHide} style={liuziStyles.toastStyle} mode={JDToast.MODE.MODAL}>
					{this.state.errMsg}
				</JDToast>
			</View>
		)
	}
}
const liuziStyles = StyleSheet.create({
	liuziContainer: {
		position: 'absolute',
		bottom: 0,
		right: 0,
		width: JDDevice.getRpx(750),
		minHeight: JDDevice.getRpx(540),
		borderTopLeftRadius: JDDevice.getRpx(30),
		borderTopRightRadius: JDDevice.getRpx(30),
		backgroundColor: '#ffffff'
	},
	liuziBox: {
		paddingHorizontal: JDDevice.getRpx(46)
	},
	titleBox: {
		justifyContent: 'center',
		paddingVertical: JDDevice.getRpx(50),
		paddingHorizontal: JDDevice.getRpx(40),
	},
	titleText: {
		fontSize: JDDevice.getRpx(40),
		fontWeight: 'bold',
		color: '#424854',
		textAlign: 'center'
	},
	tipsBox: {
		paddingBottom: JDDevice.getRpx(20),
	},
	tipsText: {
		fontSize: JDDevice.getRpx(28),
		color: '#848689'
	},
	telBox:{
		display: 'flex',
		flexDirection:'row',
		alignItems: 'center',
		width: '100%',
		justifyContent: 'space-between',
		height: JDDevice.getRpx(90),
	},
	telDeleBox: {
		width: JDDevice.getRpx(100),
		height: JDDevice.getRpx(90),
		display: 'flex',
		flexDirection:'row',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},
	vertycodeBox: {
		width: JDDevice.getRpx(270),
		height: JDDevice.getRpx(90),
		display: 'flex',
		flexDirection:'row',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},
	telInput: {
		width: JDDevice.getRpx(550),
		height: JDDevice.getRpx(90),
		paddingVertical: 0,
		fontSize: JDDevice.getRpx(30),
		backgroundColor: 'rgba(255,255,255,1)'
	},
	yanzhengInput: {
		width: JDDevice.getRpx(380),
		height: JDDevice.getRpx(90),
		paddingVertical: 0,
		fontSize: JDDevice.getRpx(30),
		backgroundColor: 'rgba(255,255,255,1)'
	},
	telDeleIcon: {
		width:JDDevice.getRpx(25),
		height:JDDevice.getRpx(25),
	},

	line: {
		width: '100%',
		height: JDDevice.getRpx(1),
		borderTopWidth: JDDevice.getDpx(1),
		borderStyle: 'solid',
		borderColor: '#e3e5e9'
	},
	agreeBox:{
		display: 'flex',
		flexDirection:'row',
		width: '100%',
		alignItems: 'center',
		height: JDDevice.getRpx(90),
	},
	agreeIconBox:{
		display: 'flex',
		flexDirection:'row',
		width: '100%',
		alignItems: 'center',
		height: JDDevice.getRpx(90),
	},
	agreeIcon: {
		width:JDDevice.getRpx(26),
		height:JDDevice.getRpx(26),
		marginRight: JDDevice.getRpx(10)
	},
	agreeText: {
		fontSize: JDDevice.getRpx(24),
		color: '#bcbdc2'
	},
	agreeConText: {
		fontSize: JDDevice.getRpx(24),
		color: '#fa2c19'
	},
	btnBox: {
		width: JDDevice.getRpx(680),
		height: JDDevice.getRpx(76),
		backgroundColor: '#fa2c19',
		borderRadius: JDDevice.getRpx(39),
		justifyContent: 'center',
		marginBottom: JDDevice.getRpx(60),
	},
	btnText: {
		fontSize: JDDevice.getRpx(28),
		color: '#ffffff',
		textAlign: 'center',
	},
	toastStyle: {
		backgroundColor: "rgba(0,0,0,0.6)"
	},
});
